/** Local (email + password) staff session persisted in localStorage. */
export interface LocalSession {
  token: string;
  /** ISO timestamp from the API. */
  expiresAt: string;
  user: { name: string; email: string; role: string };
}

const KEY = "aurumiq:admin-session";
const listeners = new Set<() => void>();

// Cached parse so useSyncExternalStore gets a referentially stable snapshot.
let cachedRaw: string | null | undefined;
let cached: LocalSession | null = null;

export function readSession(): LocalSession | null {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(KEY);
  } catch {
    raw = null;
  }
  if (raw === cachedRaw) {
    if (cached && Date.parse(cached.expiresAt) <= Date.now()) writeSession(null);
    return cached;
  }
  cachedRaw = raw;
  cached = null;
  if (raw) {
    try {
      const s = JSON.parse(raw) as LocalSession;
      cached = s.token && Date.parse(s.expiresAt) > Date.now() ? s : null;
    } catch {
      cached = null;
    }
  }
  return cached;
}

export function writeSession(s: LocalSession | null): void {
  try {
    if (s) localStorage.setItem(KEY, JSON.stringify(s));
    else localStorage.removeItem(KEY);
  } catch {}
  cachedRaw = undefined;
  for (const l of listeners) l();
}

export function subscribe(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
